(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws_amplify_core"), require("graphql"), require("aws_amplify_auth"), require("aws_amplify_cache"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_api", ["aws_amplify_core", "graphql", "aws_amplify_auth", "aws_amplify_cache"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_api"] = factory(require("aws_amplify_core"), require("graphql"), require("aws_amplify_auth"), require("aws_amplify_cache"));
	else
		root["aws_amplify_api"] = factory(root["aws_amplify_core"], root["graphql"], root["aws_amplify_auth"], root["aws_amplify_cache"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 